/**
 * @component
 *
 * Formattatori comuni
 */
export default {

	resa: (props, path = null) => {

		if (path != null && path != '/accreditamento/richieste' && path != '/provedimenti/lista') return true;

		let autodichiarazione_nuovo_rl_resa = 
		props && props.UserStore && props.UserStore.user &&
		props.UserStore.user.ente     && props.UserStore.user.ente.storicoRL
		? 
		props.UserStore.user.ente.storicoRL.autodichiarazione
		:
		true;
		;
		return autodichiarazione_nuovo_rl_resa;
	},

}